export default "/images/logo-18.png?05a3c9f2e7577aa20b99fdb5e28357fa";